import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import './App.css';

import EvoRecebimentos from './Components/Screens/EvoRecebimentos/EvoRecebimentos';
import EvoPagamentos from './Components/Screens/EvoPagamentos/EvoPagamentos';
import * as lottie from './assets/lotties/loading.json';
import Loading from './Components/Screens/Loading';

import { Context } from './Context';


export default () => {

  const { loading } = useContext(Context)

  const [closing, setClosing] = useState(false)
  const [closed, setClosed] = useState(false)

  useEffect(() => {
    closing && setTimeout(() => setClosing(false), 1050)
    closing && setTimeout(() => setClosed(true), 1000)
  }, [closing])

  useEffect(() => {
    loading && setClosed(false)
    !loading && setClosing(true)
  }, [loading])

  return (
    <div className="app">
      <header className="main-header py-2 px-3 position-sticky top-0 z-3">Dashboard</header>
      { !closed && (
        <div className={'position-fixed d-flex flex-column align-items-center justify-content-center bg-dark loading-screen ' + (closing ? 'loading-closing' : '')}>
          <div className="loading-lottie">
            <Lottie animationData={lottie} autoplay loop className='mn-5' />
          </div>
          <p className="h2">
            Carregando...
          </p>
        </div>
      ) }
      <div className="overflow-auto">
        <div className="screen-content">
          <BrowserRouter>
            <Routes>
              <Route path='*' element={<Loading />} />
              <Route path='/dashboard/evo_recebimentos' element={<EvoRecebimentos />} />
              <Route path='/dashboard/evo_pagamentos' element={<EvoPagamentos />} />
            </Routes>
          </BrowserRouter>
        </div>
      </div>
    </div>
  )
}
